export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11254.d755b54c.jpg";